import React, { useEffect } from 'react'
import { useState } from 'react'
import css from './ListUser.module.scss'
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { et } from 'date-fns/locale';
import { createUser, getListGroup, getUserByUsername, updateUser } from '../../../Services/Admin/ListAdminServices';
import { doDeleteAdmin, doDeleteUser } from '../../../Services/Admin/AuthAdminSevices';
const EditUserEnergyPage = () => {
    const {register, handleSubmit, setValue, formState: { errors }, reset} = useForm();
    const navigate = useNavigate();
    const { username } = useParams();

    const [buttonClicked, setButtonClicked] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [StatusCheckPLTS, setCheckPLTS] = useState(false);
    const [isDeletedPopup, setisDeletedPopup] = useState(false);
    const [isSuccessDeleted, setIsSuccessDeleted] = useState(false);
    const [isError, setIsError] = useState(false);
    const [dataUser, setDataUser] = useState({});
    const [isErrorMessage, setIsErrorMessage] = useState(false);
    
    const [IdGroupAPI, setIdGroupAPI] = useState(false);
    const [IdUserAPI, setIdUserAPI] = useState(false);


    const showModal = () => setIsSuccess(true);
    const hideModal = () => {
        setisDeletedPopup(false)
        setIsSuccess(false)
        // reset()
    };

    const handleDeleteConfirm = () => {
        doDeleteUser(dataUser).then((result) => {
            setisDeletedPopup(false)
            setIsSuccessDeleted(true)
        }).catch(({ response }) => {
            console.log(response)
        });
    };
    function onCreate(data) {
        // alert('asd')
        // console.log(data)
        if(buttonClicked == 'save'){
            updateUser(atob(username), data).then((result) => {    
                setIsSuccess(true)
            }).catch(({ response }) => {
                console.log(response)
                setIsError(true)
                setIsErrorMessage(response.data.message)
            });
        }
    }
    const FindGroup = (value) => {
        let data =  value
        getListGroup(data).then((result) => {    
            console.log(result.data)
            setValue('group_id', data)
            setValue('huawei_username', result.data.data.name)
            setValue('huawei_password', result.data.data.password)
            setValue('current_user', result.data.total)
        }).catch(({ response }) => {
            console.log(response)
        });
        setCheckPLTS(true)
    }
    
    const searchGroup = (e) => {
        let data =  e.target.value
        getListGroup(data).then((result) => {    
            console.log(result.data)
            setValue('group_id', data)
            setValue('huawei_username', result.data.data.name)
            setValue('huawei_password', result.data.data.password)
            setValue('current_user', result.data.total)
        }).catch(({ response }) => {
            console.log(response)
        });
        setCheckPLTS(true)
    }

    const FindUser = (username) => {
        getUserByUsername(atob(username)).then((result) => {    
            setDataUser(result.data[0]._id)
            setIdUserAPI(result.data[0]._id)
            setIdGroupAPI(result.data[0].group_id)
            setValue('username', result.data[0].username)
            setValue('name', result.data[0].name)
            setValue('email', result.data[0].email)
            setValue('phone', result.data[0].phone)
            setValue('station_code', result.data[0].station_code)
            FindGroup(result.data[0].group_id)
        }).catch(({ response }) => {
            console.log(response)
        });
        setCheckPLTS(true)
    }

    useEffect(() => {
        FindUser(username)
    }, [])
    

  return (
    <div className='wrap_admin'>
        {isSuccess && 
            <div className={css.popup_wrap} onClick={hideModal}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                    <img src="/monitoring/assets/success.png" />
                    <b>Successful!</b>
                    <p>The Data has just been updated. </p>
                </div> 
            </div>
        }
        
        {isSuccessDeleted && 
            <div className={css.popup_wrap} onClick={()=>navigate(-1)}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={()=>navigate(-1)}></i>
                    <img src="/monitoring/assets/success.png" />
                    <b>Successful!</b>
                    <p>The Data has just been deleted. </p>
                </div> 
            </div>
        }
        
        {isDeletedPopup && 
            <div className={css.popup_wrap} onClick={hideModal}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                    <img src="/monitoring/assets/delete.png" />
                    <b>Delete Confirmation</b>
                    <p>You are about to delete this station, are you sure?</p>
                    <button onClick={hideModal} className='admin-button cancel'>No</button>
                    <button onClick={handleDeleteConfirm} className='admin-button delete'>Yes</button>
                </div> 
            </div>
        }
        
        {isError && 
            <div className={css.popup_wrap} onClick={()=> setIsError(false)}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={()=> setIsError(false)}></i>
                    <img src="/monitoring/assets/error.png" />
                    <b>Error!</b>
                    <p>{isErrorMessage} </p>
                </div> 
            </div>
        }
        <div className='row vh-100'>
            <div className='col-md-12' style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>
                <div className={`${css.content_position} row`} style={{ marginBottom: 100 }}>
                    <form className={`${css.form}`} onSubmit={handleSubmit(onCreate)}>
                        <div className='row'>
                            <div className='col-md-6'>
                                <label>Username</label>
                                <input type='text' placeholder='Add Username' disabled style={{background:'#F5F5F5'}}
                                    {...register("username", { 
                                        required: "This field is required"
                                    })}
                                />
                                {errors.username && <p style={{color:'red'}}>This field is required</p>}

                                <label>Name</label>
                                <input type='text' placeholder='Add Name' 
                                    {...register("name", { 
                                        required: "This field is required"
                                    })}
                                />
                                {errors.name && <p style={{color:'red'}}>This field is required</p>}
                                
                                <label>Email</label>
                                <input type='text' placeholder='Add Email'
                                    {...register("email", {
                                        required: "Email is required",
                                        pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: "Invalid email address"
                                        }
                                    })} 
                                />
                                {errors.email && <p style={{color:'red'}}>This field is required</p>}
                                

                                <label>Phone Number</label>
                                <input type='text' placeholder='Add Phone number' 
                                    {...register("phone", { 
                                        required: "This field is required"
                                    })}
                                />
                                {errors.phone && <p style={{color:'red'}}>This field is required</p>}
                                
                            </div>
                            <div className='col-md-6'>
                                <label>Group</label>
                                <select onChange={searchGroup}>
                                    <option value={''}>Choose Group</option>
                                    <option value={1} selected={IdGroupAPI == 1 && true}>Group 1</option>
                                    <option value={2} selected={IdGroupAPI == 2 && true}>Group 2</option>
                                    <option value={3} selected={IdGroupAPI == 3 && true}>Group 3</option>
                                    <option value={4} selected={IdGroupAPI == 4 && true}>Group 4</option>
                                </select>
                                
                                <label>username</label>
                                <input type='text' placeholder='Add Email' disabled style={{background:'#F5F5F5'}}
                                    {...register("huawei_username", { required: true })}   
                                />
                                {errors.huawei_username && <p style={{color:'red'}}>This field is required</p>}
                                
                                
                                <label>Password</label>
                                <input type='text' placeholder='Add Password' disabled  style={{background:'#F5F5F5'}}   
                                    {...register("huawei_password", { required: true })}     
                                />
                                {errors.huawei_password && <p style={{color:'red'}}>This field is required</p>}


                                <label>Current User</label>
                                <input type='text' placeholder='Confirm user' disabled  style={{background:'#F5F5F5'}}
                                    {...register("current_user", { required: true })}   
                                />
                                {errors.current_user && <p style={{color:'red'}}>This field is required</p>}

                                
                                <label>Station</label>
                                <input type='text' placeholder='Add Station'
                                    {...register("station_code", { required: true })}   
                                />
                                {errors.station_code && <p style={{color:'red'}}>This field is required</p>}

                                
                            </div>
                        </div>
                        

                        <div className='row' style={{marginTop:40, marginLeft:-15}}>
                            <div className='col-md-8'>
                                <button className='admin-button delete' onClick={() => setisDeletedPopup(true)}>Delete</button>
                            </div>
                            <div className='col-md-4' style={{float:'right'}}>
                                <button className='admin-button cancel' onClick={() => navigate(-1)} style={{marginRight:10}}>Cancel</button>
                                <button className='admin-button save' onClick={() => setButtonClicked('save')} disabled={StatusCheckPLTS == false ? true : false} >Save</button>  
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default EditUserEnergyPage